export const HISTORY_ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  MANIPULATION: 'MANIPULATION',
};
